import React, { useEffect, useState } from "react";
import "./Popup.css";

const Popup = () => {
  const [isPopupAccepted, setIsPopupAccepted] = useState(false);

  useEffect(() => {
    const popup = localStorage.getItem("popup");
    if (popup) {
      setIsPopupAccepted(true);
    }
  }, []);

  function addPopupCookie() {
    localStorage.setItem("popup", "1");
    setIsPopupAccepted(true);
  }

  return (
    !isPopupAccepted && (
      <form className="lottolegenda-popup-cookie">
        <h2 className="lottolegenda-popup__header">Cookie Notice</h2>
        <p>
          We use cookies to improve your experience on our site. By continuing,
          you agree to our use of cookies as outlined in our Privacy Policy.
        </p>
        <div className="lottolegenda-popup__btn-container lottolegenda-cookie-popup__btn-container">
          <button
            className="lottolegenda-popup__btn lottolegenda-popup__btn-main lottolegenda-popup__btn-agree"
            onClick={addPopupCookie}
          >
            Accept
          </button>
          <a
            href="/cookies"
            className="lottolegenda-popup__btn lottolegenda-popup__btn-second"
          >
            Learn more
          </a>
        </div>
      </form>
    )
  );
};

export default Popup;
